import { Trans } from '~/common/context';
import { Button, Icon, Text } from '@wyz/ui';
import { SupplierButton } from '~/connect/components';
import * as React from 'react';
type Props<T> = {
  isAdded: boolean;
  label: React.ReactNode;
  value: string;
  item: T;
  onConfigure?: (item: T) => void;
  onAdd?: (item: T) => void;
  onRemove?: (item: T) => void;
  canAdd: boolean;
  canRemove: boolean;
  canConfigure?: boolean;
};
const AlphabeticalListItem = <T,>({
  label,
  value,
  isAdded,
  item,
  onAdd,
  onRemove,
  onConfigure,
  canConfigure = false,
  canAdd = false,
  canRemove = false,
}: Props<T>) => {
  return (
    <SupplierButton>
      {isAdded && (
        <div>
          <Icon
            className='text-success-text'
            icon='check-mark-line'
            width={20}
            height={20}
          />
        </div>
      )}
      <Text heading='normal'>{label}</Text>
      <div className='hoverable-btn position-absolute' style={{ right: 0 }}>
        {canConfigure && onConfigure && (
          <Button
            id={`configure-${value}`}
            variant='secondary'
            size='sm'
            onClick={() => onConfigure(item)}
          >
            <Icon icon='edit' width={20} height={20} />
            <span>
              <Trans i18nKey='app.common.button.configure' />
            </span>
          </Button>
        )}
        {isAdded ? (
          canRemove && onRemove ? (
            <Button
              id={`remove-${value}`}
              variant='secondary'
              size='sm'
              onClick={() => onRemove(item)}
            >
              <Icon icon='minus' width={20} height={20} />
              <span>
                <Trans i18nKey='app.common.buttons.remove' />
              </span>
            </Button>
          ) : (
            <></>
          )
        ) : canAdd && onAdd ? (
          <Button
            id={`add-${value}`}
            variant='secondary'
            size='sm'
            onClick={() => onAdd(item)}
          >
            <Icon icon='plus' width={20} height={20} />
            <span>
              <Trans i18nKey='app.common.button.add' />
            </span>
          </Button>
        ) : (
          <></>
        )}
      </div>
    </SupplierButton>
  );
};

export default AlphabeticalListItem;
